import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Label, Message, Segment, Image } from 'semantic-ui-react';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './Release.css';
const cx = classNames.bind(styles);

class Release extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx('release-grid-box')}>
        <div className={cx('release-content')}>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.1<span className={cx('release-version-title-date')}>( 2020-07-13 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 웹 에디터 도움말 글씨 잘보이도록 개선 [dev/#543]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 에디터의 변수가 틀릴경우 메일이 발신되지 않는 현상 개선 [dev/#544]
                </div>

              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 서비스 공유한 A사용자 탈퇴 후 공유받은 B사용자가 A사용자의 정보 조회 가능한 오류 수정 [dev/#531]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 웹 에디터 그림 업로드 버그 수정 [dev/#540]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 결과보깉 탭 레이아웃 이상 현상 수정 [dev/#536]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. 기간라이센스 선택시 유효기간 하이라이팅 버그 수정 [dev/#546]
                </div>

                <div className={cx('release-version-list-title')}>
                  5. 로그조회시 '로그가 존재하지 않습니다' 표시되는 현상 수정 [dev/#503]
                </div>

                <div className={cx('release-version-list-title')}>
                  6. 에디터에서 이미지가 2개이상일 경우 마지막에 등록한 1개의 이미지만 표시되는 버그 수정 [dev/#552]
                </div>

                <div className={cx('release-version-list-title')}>
                  7. 훈련기간 수정시 캘린더 잘림 버그 수정 [dev/#549]
                </div>

                <div className={cx('release-version-list-title')}>
                  8. 일본 버전일때 이메일 변경시 이메일변경후 인증페이지가 한글로 나타남 [dev/#569]
                </div>

              </div>

            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-19<span className={cx('release-version-title-date')}>( 2020-07-02 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. mudmin 로그탭에서 로그상세를 1개만 확장할 수 있도록 수정 [dev/#503]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 결과보기 내 정렬방법에 '메일', '이름' 추가 [dev/#403]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 구축형일때 라이센스 파일을 웹에서 업로드 할 수 있는 페이지 추가 [dev/#525]
                </div>

              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 템플릿 리스트에서 체크박스 위치 변하는 버그 수정 [dev/#502]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 이미지 깨지는 현상으로인한 에디터 교체 [dev/#455]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 화면크기에 따라 피싱편집기에서 이미지 목록 안보이는 버그 수정 [dev/#509]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. 영문일경우 훈련보고서 다운로드시 파일명을 훈련명_Report로 변경 [dev/#505]
                </div>

                <div className={cx('release-version-list-title')}>
                  5. 실제 로그상세내역이 있다면 표시되기전 로딩처리 [dev/#503]
                </div>
                
                <div className={cx('release-version-list-title')}>
                  6. HTML 첨부의 훈련유형 다운로드 안되는 버그 수정 (인코딩 문제) [dev/#516]
                </div>

                <div className={cx('release-version-list-title')}>
                  7. IE 피싱페이지 HTML편집기에서 태그내에서 드래그가 되지 않는 버그 수정[dev/#506]
                </div>
                
                <div className={cx('release-version-list-title')}>
                  8. 훈련 템플릿 수정 버튼 클릭 시 같은 템플릿일 경우 결과화면 미출력 버그 수정[dev/#521]
                </div>
                
                <div className={cx('release-version-list-title')}>
                  9. 훈련생성 중 대상관리에 한명도 없을때 훈련생성과정이 계속 진행되는 버그 수정[dev/#522]
                </div>

              </div>

            </div>
          </div>


          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-18<span className={cx('release-version-title-date')}>( 2020-06-25 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 훈련템플릿 관리 리스트에 피싱페이지 필드 추가 [dev/#375]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 크롬으로 피싱페이지 편집서 이미지 업로드시 업로드 가능 확장자 명시 [dev/#485]
                </div>

              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 브라우저의 height을 낮게하고 아래로 스크롤할 경우 흰화면 표기된 버그 수정 [dev/#493]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. IE 브라우저 피싱 유형 템플릿 수정 Phishing induction settings 선택되지 않는 버그 수정 [dev/#494]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 버전업 이전에 실시한 훈련중 훈련시작 30일이내인 피싱유형의 훈련 결과 화면 마이그레이션 [dev/#501]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. 메일 클라이언트, 모바일 에서 신고하기 배너 표시되지 않는 버그 수정 [dev/#496][dev/#500]
                </div>

                <div className={cx('release-version-list-title')}>
                  5. 서비스가입후 로그인할경우 기본값이 한글로 설정되는 버그 수정 [dev/#435]
                </div>

              </div>

            </div>
          </div>


          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-17<span className={cx('release-version-title-date')}>( 2020-06-24 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. mudmin에서 첨부파일 등록버튼 제거 [dev/#372]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 기본 피싱페이지도 복제할 수 있도록 기능 추가 [dev/#486]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. mudfix.jp에서 피싱페이지의 결과화면은 사용자는 js/css 이용 불가능 [dev/#448]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. mudfix.jp에서 라이센스 신청 버튼 삭제 [dev/#466]
                </div>

                <div className={cx('release-version-list-title')}>
                  5. 피싱페이지 복제시 html의 img태그의 이미지 url도 변경되어서 복제 [dev/#476]
                </div>

              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 신규구축일경우 관리자페이지의 설정페이지 항목이 표기안되는 버그 수정 [dev/#483]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 일본, 영문 버전일경우 "첨부파일 감추기 비율" 항목  "Masking rate of file name" 로 표기 되도록 변경 [dev/#472]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 진행중인 훈련에 대하여 누락된 마이그레이션 코드 추가 [dev/#481]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. 서비스 등록 시 등록하기 버튼 미작동 버그 수정 [dev/#489]
                </div>

                <div className={cx('release-version-list-title')}>
                  5. 일본버전에서 mudmin일 경우 라이센스 발급버튼 표기 [dev/#492]
                </div>

                <div className={cx('release-version-list-title')}>
                  6. 신규 템플릿 마이그레이션 실패하는 버그 수정 [dev/#490]
                </div>

              </div>

            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-16<span className={cx('release-version-title-date')}>( 2020-06-22 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 모바일로 mudfix.jp 접속시 redirection url 수정 [dev/#477]
                </div>

              </div>

            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-15<span className={cx('release-version-title-date')}>( 2020-06-22 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 마이그레이션 버그 수정 [dev/#448]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 쿼리 중간에 세미콜론(;) 삽입으로 인한 문법 에러 수정
                </div>
                <div className={cx('release-version-list-content')}>
                  - 마이그레이션 후 수신 테스트 안되는 버그 수정
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 기본템플릿의 복제 후 비공개 처리시 메일 발송이 되지 않는 현상 수정 [dev/#478]
                </div>

              </div>

            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-14<span className={cx('release-version-title-date')}>( 2020-06-18 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. [IE] Chrome에 최적화 문구 제거 [dev/#444]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. mudfix.jp에서 피싱페이지의 번역 변경 (段階 -> ステップ) [dev/#464]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. mudfix.jp에서 피싱페이지의 결과화면은 사용자는 js/css 이용 불가능 [dev/#448]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. mudfix.jp에서 라이센스 신청 버튼 삭제제 [dev/#466]
                </div>

              </div>


              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 유저 탈퇴하기에서 delete메소드로 url에 비밀번호 들어가는 문제 수정 [dev/#318]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 피싱용 업로드 파일 유실 확인 [dev/#442]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 피싱 페이지 내용의 이미지들이 해당 피싱페이지에 종속 되도록 수정
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 기본템플릿 수신테스트 시 수신확인메일 미발송 문제 수정 [dev/#431]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. mudmin에서 활성화인 사용자를 등록할 경우 이메일 인증메일 발송안하도록 수정 [dev/#467]
                </div>

              </div>

            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-13<span className={cx('release-version-title-date')}>( 2020-06-10 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 피싱 페이지 이미지 업로드 보존 + 삭제기능 개선 [dev/#442]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 이미지 업로드시 해당 피싱페이지에서 이미지 보존, 삭제 개선
                </div>
                <div className={cx('release-version-list-content continue')}>
                  수정 (列->行, 失敗理由->失敗した行)
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 템플릿 수정에서 이미지 복사 붙여넣기 기능개선 [dev/#349]
                </div>
              </div>


              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. IE에서 신고하기 팝업창이 url인코딩 문제로 표기되지 않는 버그 수정 [dev/#443]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 서비스 번호 미지정 복사일 경우 복사되지 않는 버그 수정 [dev/#441]
                </div>
              </div>

            </div>
          </div>


          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-12<span className={cx('release-version-title-date')}>( 2020-06-08 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 피싱결과화면 HTML편집기능 제공 [dev/#411]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 결과 화면 수정을 훈련 템플릿에서 관리하지않고 피싱페이지 탭에서 관리 함
                </div>
                <div className={cx('release-version-list-content continue')}>
                  결과화면 수정을 코드로 수정이 가능하게 됨
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 'KF94 마스크 사전예약구매' 기본 피싱템플릿 추가 [dev/#438]
                </div>
              </div>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 일본어 화면에서 일본어 출력 변경 [dev/#413][dev/#437]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 디바이스 타입 -> デバイスタイプ, 디바이스 정보 -> デバイス情報
                </div>
                <div className={cx('release-version-list-content continue')}>
                  수정 (列->行, 失敗理由->失敗した行)
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 대상자 이름에 사용할 수 있는 문자열 추가 [dev/#400]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 일본어 「－」,「ゞ」,「々」,「ゝ」허용하도록
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 아웃룩 메일 전송 시 이미지 본문 삽입에 대한 방안 요청 [dev/#388]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 인라인 이미지 활용하여 아웃룩메일에 이미지 표기
                </div>
              </div>


              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 검색필터 팝업표시 중 OK, Cancel 눌러도 팝업 제거되지 않는 버그 수정 [dev/#376]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 피싱 훈련 템플릿 수정 화면에서 훈련 메일 본문에 예약어가 표시되지않은 버그 수정 [dev/#421]
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 서비스 공유 사용자 삭제 후에도 훈련결과가 보이도록 수정 [dev/#425]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. 특정한경우 기본템플릿 수신테스트 시 수신확인메일 미발송 버그 수정 [dev/#431]
                </div>

                <div className={cx('release-version-list-title')}>
                  5. 수신테스트 일문 수정, 수신확인 from 값 수정 [dev/#430]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 수신 테스트를 실행시의 송신지를 지정하는 개소의 표시가 "송신원 메일 주소" -> "송신처 메일 주소" 수정
                </div>
                <div className={cx('release-version-list-content')}>
                  - 수신테스트할 경우 From 주소가 템플릿의 From 주소로 나오도록 수정
                </div>

                <div className={cx('release-version-list-title')}>
                  6. 라이선스 발급 메일 오타 수정 [dev/#432]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 라이센스 타입이 반대로 표기되는 버그 수정
                </div>
                <div className={cx('release-version-list-content')}>
                  - 일본어 화면에서 불필요한 텍스트 삽입되어 발급메일 발송되던 버그 수정
                </div>

                <div className={cx('release-version-list-title')}>
                  7. 신규기능 추가로 피싱템플릿 수신테스트할 경우 화면 미표기 되던 버그 수정 [dev/#433]
                </div>

                <div className={cx('release-version-list-title')}>
                  8. 특정한 상황에 최초 로그인 시 한글 표시 오류 수정 [dev/#435]
                </div>

                <div className={cx('release-version-list-title')}>
                  9. 디바이스 정보 추가로 인해 열람할경우 보고서 다운로드 안되는 버그 수정 [dev/#436]
                </div>
              </div>

            </div>
          </div>


          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-11<span className={cx('release-version-title-date')}>( 2020-05-29 )</span>
            </div>
            <div className={cx('release-version-list')}>


              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 사용자가 추가한 피싱페이지의 복제기능 제공 [dev/#397]
                </div>
              </div>


              <div className={cx('release-version-type')}>개선 사항</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. Mudfix로 되어있는 부분 MudFix로 일괄 변경 [dev/#402]
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 사이트 관련 이미지 및 컨텐츠 변경 [dev/#365]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 사용자 매뉴얼 내용 (ssr관련 -> jiran관련) 이미지 로고 변경
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 대상자 이름에 사용할 수 있는 문자열 추가 [dev/#400]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 일본어 「－」,「ゞ」,「々」,「ゝ」허용하도록 추가
                </div>
              </div>


              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>

                <div className={cx('release-version-list-title')}>
                  1. 19번 첨부파일 실행시 감염처리 안됨 [dev/#301]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 구축형일 경우 https -> http로 변경
                </div>

                <div className={cx('release-version-list-title')}>
                  2. 일문버전의 피싱페이지 등록 시 국문표기 오류 수정 [dev/#398]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 피싱 메일 본문 작성 예시 일문, 영문, 국문화
                </div>

                <div className={cx('release-version-list-title')}>
                  3. 교육 페이지 IE 접속 불가 버그 수정 [dev/#399]
                </div>

                <div className={cx('release-version-list-title')}>
                  4. 보고서 다운로드 실패 버그 [dev/#380]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 훈련보고서에서 피싱이름을 표기할때 DB에서 템플릿의 피싱넘버와 맵핑 하여 표기
                </div>
                <div className={cx('release-version-list-content continue')}>
                  ( 피싱페이지 추가로 발생한 이슈 )
                </div>
              </div>

            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-10<span className={cx('release-version-title-date')}>( 2020-05-22 )</span>
            </div>
            <div className={cx('release-version-list')}>

              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [부산은행] MudFix 인사연동 정보 전달 [dev/#380]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [MudFix] 일본/한국/구축형/서비스형/교육관리/신고관리 도커이미지 통합 [dev/#386]
                </div>
              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 이메일 컨텐츠에 다운로드 버튼 예약어를 입력하였지만 버튼이 표시되지 않음 [dev/#358]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 전체 훈련 결과 그래프 개선 [dev/#325]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. 교육동영상 시청 중 컨트롤 보기 선택시 빨리감기 가능한 현상 [dev/#382]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. [MudFix] celery에서 고객사 모든 연동모듈이 실행되고 있음 [dev/#380]
                </div>
                <div className={cx('release-version-list-title')}>
                  5. [MudFix] 이미지로 신규 구축할 경우에 마이그레이션 장애 [dev/#384]
                </div>
                <div className={cx('release-version-list-title')}>
                  6. 템플릿 생성시 유효성검사중 누락된 항목이 있을경우 Save버튼 비활성화 [dev/#381]
                </div>
                <div className={cx('release-version-list-title')}>
                  7. 피싱페이지 목록에서 훈련생성시 피싱페이지 목록 이상현상 [dev/#385]
                </div>
                <div className={cx('release-version-list-title')}>
                  8. 자바스크립트 입력영역 하단 흰색영역 제거 [dev/#389]
                </div>
                <div className={cx('release-version-list-title')}>
                  9. 목록 선택시 체크 박스 동작되지 않는 현상 [dev/#366]
                </div>
                <div className={cx('release-version-list-title')}>
                  10. [MudFix] 사이트 관련 이미지 및 컨텐츠 변경 [dev/#365]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-9<span className={cx('release-version-title-date')}>( 2020-05-20 )</span>
            </div>
            <div className={cx('release-version-list')}>

              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [평택시청] 교육관리 영상 컨텐츠 추가 요청 [dev/#321]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [MudFix] Docker Container 실행시 일본 한국 구분 [dev/#347]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [MudFix] 경고안내 유형 치료단계 표시 [dev/#359]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. [Mudfix] 종료된 훈련의 설정 수정 [dev/#356]
                </div>
                <div className={cx('release-version-list-title')}>
                  5. [Mudfix] HTML 에디터에서 마우스 드래그 동작시 표시색상 개선요청 [dev/#364]
                </div>
                <div className={cx('release-version-list-title')}>
                  6. [Mudfix] 사이트 관련 이미지 및 컨텐츠 변경 [dev/#365]
                </div>
              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 다른 훈련 선택 후 해당 훈련 선택 시 결과 리프레시 다르게 동작되는 현상 개선 [dev/#345]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 이메일 컨텐츠에 다운로드 버튼 예약어를 입력하였지만 버튼이 표시되지 않음 [dev/#358]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [MudFix] 피싱페이지 등록되지 않는 현상 [dev/#360]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. Reserved word 문구 잘려 보임 [dev/#367]
                </div>
                <div className={cx('release-version-list-title')}>
                  5. 템플릿 검색시 검색항목의 글자수가 길경우 영역초과되어 보임 [dev/#368]
                </div>
                <div className={cx('release-version-list-title')}>
                  6. Script Editor에서 편집시 Javascript가 Load되는 현상 [dev/#370]
                </div>
                <div className={cx('release-version-list-title')}>
                  7. [평택시청] 교육관리 진행률이 100%를 초과하는 이슈 [dev/#369]
                </div>
                <div className={cx('release-version-list-title')}>
                  8. [MudFix] 리포트 다운로드 되지 않는 현상 [dev/#316]
                </div>
                <div className={cx('release-version-list-title')}>
                  9. [MudFix] Phishing page 목록에서 ASC, DESC 정렬되지 않음 [dev/#374]
                </div>
                <div className={cx('release-version-list-title')}>
                  10. [MudFix] 피싱페이지 삭제시 upload image 접근여부 개선 [dev/#378]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-8<span className={cx('release-version-title-date')}>( 2020-05-18 )</span>
            </div>
            <div className={cx('release-version-list')}>

              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 훈련생 배치 등록시 등록 결과 개선 [dev/#324]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [한국환경공단]열람시 발생하는 디바이스 정보를 확인 [dev/#342]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [SK하이닉스] 중문 템플릿 적용 요청 [dev/#346]
                </div>
              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. API 접속 시도시 500 code 리턴되는 현상 [dev/#338]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 이전 비밀번호와 동일한 비밀번호로 변경시 예외처리 수정 [dev/#337]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. IE에서 Attachment Add-ons UI 텍스트 겹쳐서 보이는 현상 [dev/#341]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. Tag 검색 시 페이지 로딩 개선 [dev/#330]
                </div>
                <div className={cx('release-version-list-title')}>
                  5. 훈련 생성시 PC잠금 화면 실행시간에서 '시간' 과 '분'이 적용되지 않는 현상 [dev/#344]
                </div>
                <div className={cx('release-version-list-title')}>
                  6. Test email 로 메일 전송되지 않는 현상 [dev/#351]
                </div>
                <div className={cx('release-version-list-title')}>
                  7. 단일 Tag 선택 후 다중조건(AND) 선택시 대상자 결과의 Tag 표현 상이 [dev/#329]
                </div>
                <div className={cx('release-version-list-title')}>
                  8. Log 다운로드 UI 개선 [dev/#354]
                </div>
                <div className={cx('release-version-list-title')}>
                  9. 관리자 페이지에서 사용자 삭제 기능 개선 [dev/#350]
                </div>
                <div className={cx('release-version-list-title')}>
                  10. Log 다운로드시 Details 정보 나타나지 않는 현상 [dev/#355]
                </div>
                <div className={cx('release-version-list-title')}>
                  11. 패스워드 찾기 개선 및 3일초과 연결 페이지 오류 [dev/#340]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-7<span className={cx('release-version-title-date')}>( 2020-05-13 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [Jsecurity] 닫기 버튼 제거 (파일누락으로 변경 안됨) [dev/#322]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-6<span className={cx('release-version-title-date')}>( 2020-05-12 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [한국환경공단] MudFix 온라인 명예훼손관련 출석통지서 템플릿 본문 내 이미지 표기 안됨 [dev/#297]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [Jsecurity] 일문 UI에 국문 버튼 노출 [dev/#319]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [MudFix] 관리자 페이지에서 대상자 추가되지 않는 현상 [dev/#310]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. [Jsecurity] 아이폰 접속 시 표시 개선 [dev/#322]
                </div>
                <div className={cx('release-version-list-title')}>
                  5. [MudFix] 사용자 페이지에서 대상자 등록화면에서 기존에 없는 태그 입력 후 저장시 동작 개선 [dev/#311]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-5<span className={cx('release-version-title-date')}>( 2020-05-02 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [Jsecurity] 사용자(수동) 템플릿 메일 본문이 보이지 않는 이슈 [dev/#303]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-4<span className={cx('release-version-title-date')}>( 2020-04-29 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [한국환경공단] 머드픽스 개발 건 요청 (연동관련 계정 분류 추가 그룹 생성) [dev/#292]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [한국환경공단] 머드픽스 개발 건 요청 (2번 신고하게 될경우 보고서에서 중복신고 컬럼 추가) [dev/#292]
                </div>
              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [한국환경공단] MudFix 온라인 명예훼손관련 출석통지서 템플릿 본문 내 이미지 표기 안됨 [dev/#297]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [신한생명] 19번 첨부파일 실행시 WEB에서 감염처리 안됨 [dev/#301]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [경남은행] mudfix 에서 보낸 메일을 보안 솔루션에서 열람처리로 인한 예외처리 요청 [dev/#293]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. [경남은행] 메일본문 내 이미지 표기 안됨 [dev/#302]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-3<span className={cx('release-version-title-date')}>( 2020-04-23 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [농촌진흥청] 신고양식 변경 요청 [dev/#287]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-2<span className={cx('release-version-title-date')}>( 2020-04-06 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 메일 발송전 보고서 다운로드 안되는 버그 수정
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 원본 첨부일 경우 메일발송 실패 하는 버그 수정
                </div>
                <div className={cx('release-version-list-title')}>
                  3. 피싱 결과화면 이미지 경로 오류 수정
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.7.0-release-1<span className={cx('release-version-title-date')}>( 2020-03-31 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [브릿지즈 & 덴츠] 다양한 피싱 템플릿 제공
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 피싱 템플릿 커스텀 기능
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.2-release-3<span className={cx('release-version-title-date')}>( 2020-03-26 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. Jsecurity 보고서 다운로드가 안되는 이슈
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.2-release-2<span className={cx('release-version-title-date')}>( 2020-03-23 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [Jsecurity] 소스포드사 신규 피싱 템플릿 개발요청
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [SK하이닉스] 피싱형 템플릿 개발 요청
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [MudFix] 릴리즈노트 업데이트 요청
                </div>
              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [MudFix] 교육관리 동영상 URL 수정요청
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [MudFix] 패치 진행 후 도커 볼륨으로 지정한 디렉터리의 소유자와 그룹이 맞지 않는 이슈
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.2-release-1<span className={cx('release-version-title-date')}>( 2020-03-11 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [MF][SK하이닉스] 2월 훈련 이미지 수정 건
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [SK하이닉스] 교육 동영상 시청 후 퀴즈/시험 기능 요청
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [신한생명] 대상관리 - 사번 추가
                </div>
              </div>

              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [JSecurity] 태그 선택 시 도움말 팝업에 의해 기존 요소가 가려지는 이슈
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [JSecurity] 정보수정 시 저장 버튼을 눌러도 정상적으로 반영이 되지 않는 이슈
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [MudFix] 보고서 내용이 UI 데이터와 맞지않는 이슈
                </div>
                <div className={cx('release-version-list-title')}>
                  4. [Jsecurity][MudFix] 13-jp 버전 celery-beat 프로세스가 구동이되지않는 이슈
                </div>
                <div className={cx('release-version-list-title')}>
                  5. [Jsecurity][MudFix] UI 버그 수정 - JP버전 매뉴얼 다운로드 시 상단 파일이름이 한국어로 표기되는 현상
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-11<span className={cx('release-version-title-date')}>( 2020-02-10 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 보고서 내려받기에 사용되는 이미지 URL 수정 [dev/#411]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 구축형일 경우 관리자 페이지에서 추가 수정 버튼 제거 [dev/#410]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. 훈련실시에서 모든대상자 훈련 클릭할 경우 훈련 대상자 선택 비율 비활성화 되던문제 수정 [dev/#410]
                </div>
                <div className={cx('release-version-list-title')}>
                  4. [한국환경공단][MudFix] 훈련 보고서에 발송실패 대상자 데이터 없음 - 발송실패인 경우 발송실패 표기 [DEVMF-11]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-10<span className={cx('release-version-title-date')}>( 2020-02-04 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. SMTP탭 ID, PW 항목제거 (smtp.mufix* 경우) [dev/#408]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 대상자 단일등록 - 태그 등록 기능 요청 [dev/#407]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. [한국환경공단] MudFix 인사DB 연동 태그 수정 [cs/#416]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-9<span className={cx('release-version-title-date')}>( 2020-01-31 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [SK하이닉스]중문/영문 템플릿 제작 요청 [cs/#411]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [MudFix] 교육 진행 시 발송되는 교육메일의 타이틀 변경 요청 [cs/#410]
                </div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. [한국환경공단] MudFix 인사DB 연동 적용 시 메모리 과점유 이슈 [cs/#407]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. [신한생명][MudFix] 인사연동 퍼미션 이슈 [cs/#408]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. 교육 사이트에 정상적으로 로그인 되지 않는 이슈 [cs/#417]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-8<span className={cx('release-version-title-date')}>( 2020-01-14 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 중복 태그 대상 필터 기능 추가 - '태그 and 조건 추가' [dev/#384, cs/#378]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 피싱 템플릿 제작 요청(덴츠)건 - '사서함 용량' [dev/#394, cs/#398]
                </div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 기능 수정 요청(대한법률구조공단)건 DB 연동 소속 값 수정 [dev/#393, cs/#391]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 수신테스트 - 기본템플릿을 선택하지 않을 경우 에러나는 경우 수정[dev/#348, cs/#324]
                </div>
                <div className={cx('release-version-list-title')}>
                  3. 훈련 종료 후 신고 가능 OFF 했을시 버그 수정 [dev/#397, cs/#404]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-7<span className={cx('release-version-title-date')}>( 2020-01-02 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 수신테스트 - 원하는 템플릿을 선택하여 테스트할 수 있도록 적용 [dev/#348, cs/#324]
                </div>
                <div className={cx('release-version-list-title')}>
                  2. 신고하기 - '훈련 종료 후 신고 가능' 설정(on/off) 기능 추가 [dev/#367, cs/#369]
                </div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. JP 고객사 서버에서 한국 전용 템플릿이 조회되는 버그 수정 [dev/#396, cs/#397]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-5<span className={cx('release-version-title-date')}>( 2019-12-04 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 신고 대상자 50명 이상일 때 카운팅 버그 수정 [dev/#368, cs/#369]</div>
                <div className={cx('release-version-list-content')}>
                  - 50명 이상일 경우 카운팅 정상 출력 및 대상자 30명 단위로 무한스크롤 처리
                </div>
                <div className={cx('release-version-list-title')}>2. IE 10 이하에 제공하는 미지원 브라우저 안내창이 열리자마자 닫히는 버그 수정 [dev/#363, cs/#363]</div>
                <div className={cx('release-version-list-title')}>3. IE 10 이하에서 피싱 템플릿 정상적으로 동작하도록 수정 [dev/#379, cs/#363]</div>
                <div className={cx('release-version-list-title')}>4. IE 10 이하에서 신고하기 기능 안되는 버그 수정 [dev/#365, cs/#374]</div>
                <div className={cx('release-version-list-title')}>5. 피싱 훈련 메일에서 연결 링크 클릭 시 새 창으로 열리지 않는 버그 수정 [dev/#383, cs/#380]</div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-4<span className={cx('release-version-title-date')}>( 2019-11-26 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 훈련 템플릿 첨부파일이 제대로 실행되지 않는 버그 수정 [dev/#358, cs/#348]</div>
                <div className={cx('release-version-list-content')}>
                  -
                </div>
                <div className={cx('release-version-list-title')}>2. 훈련 템플릿 수정 - 이미지 업로드 버그 수정 [dev/#362, cs/#358]</div>
                <div className={cx('release-version-list-content')}>
                  - 이미지 업로드에서 '주소(URL)'로 올리는 기능은 제거하고, '파일 업로드'로 올리는 기능만 제공
                </div>
                <div className={cx('release-version-list-title')}>3. IE 10 이하에서 특정 피싱 템플릿 링크 클릭 시 빈화면 출력되는 버그 수정 [dev/#363, cs/#363]</div>
                <div className={cx('release-version-list-content')}>
                  - IE 10 이하에서 기능을 지원하지 않는다는 안내 페이지 제공
                </div>
                <div className={cx('release-version-list-title')}>4. IE에서 피싱 메일 열었을 시 IE 7로 열리는 버그 수정 [dev/#380]</div>
                <div className={cx('release-version-list-content')}>
                  - 사용자가 사용하고 있는 최신 브라우저 버전으로 열리도록 설정
                </div>
                <div className={cx('release-version-list-title')}>5. 개발자 도구에서 주석으로 처리된 고객사 정보 보이는 버그 수정 [dev/#364]</div>
                <div className={cx('release-version-list-title')}>6. 악성모의훈련에서 백신이 작동되지 않는 버그 수정 [dev/#377, cs/#372]</div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-2<span className={cx('release-version-title-date')}>( 2019-11-07 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 악성 이메일 모의 훈련_1차시 테스트 진행의 건 [dev/#356, cs/#334]
                </div>
                <div className={cx('release-version-list-content')}>- 중화인민공화국 -> 이란으로 수정</div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 발송자명/ 수신자명 버그 수정 [dev/#347]</div>
                <div className={cx('release-version-list-content')}>
                  - 발송자의 이메일 주소이름이 이상하게 나오는 부분 수정
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.1-release-1<span className={cx('release-version-title-date')}>( 2019-11-06 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 릴리즈 노트 추가 [dev/#350]</div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>2. 신고하기 문구 수정 [dev/#349, cs/#334]</div>
                <div className={cx('release-version-list-content')}>
                  - 악성 메일 신고하기 -> 악성메일 수신자(본인) 정보 입력
                </div>
                <div className={cx('release-version-list-content')}>
                  - 신고 접수 되었습니다. -> 악성메일이 정상적으로 신고 되었습니다.
                </div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 메일 발송자가 안나오는 문제 수정 [dev/#347, cs/#322]
                </div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  2. 메일 받는사람이 안나오는 문제 수정 [dev/#347, cs/#337]
                </div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  3. make_mudfix_schema에 system_config declareType이 누락된 버그 [dev/#349, cs/#332]""
                </div>
                <div className={cx('release-version-list-content')}>
                  - make_mudfix_schema_v0.4.sql에 system_config - declareType추가
                </div>
                <div className={cx('release-version-list-content')}>
                  - migration에 339.sql추가 (declareType없을때 기존모든 system_config, service_config에 declare 관련
                  data 삭제후 다시 삽입)
                </div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  4. 메일에서 신고하기 접속 후 신고 버튼 클릭할 경우 ie에서 버튼 동작 안하는 문제 수정 [dev/#349,
                  cs/#333]
                </div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  5. 피싱 - 구글 계정 보안 템플릿에서 훈련 안내 기능이 안되는 버그 수정 [dev/#353, cs/#338]
                </div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  6. 훈련템플릿의 첨부파일을 '첨부없음'으로 선택해도 첨부링크가 메일에 있는 문제 수정 [dev/#349,
                  cs/#334]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.0-release-31<span className={cx('release-version-title-date')}>( 2019-10-23 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 머드픽스 기능 수정 요청(국립공원공단)건 - 신고기능 [dev/#346]
                </div>
                <div className={cx('release-version-list-content')}>
                  - 훈련 대상자의 신고하기 양식에 이름과 이메일 소속을 추가
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.0-release-30<span className={cx('release-version-title-date')}>( 2019-10-18 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 일본어 문구 수정 요청 [dev/#345]</div>
                <div className={cx('release-version-list-content')}> - 수정전: 受信先メールアドレス</div>
                <div className={cx('release-version-list-content')}> - 수정후: 送信元メールアドレス</div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>2. 대상자 엑셀 파일 교체 요청 [dev/345]</div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 대상자 엑셀 다운로드 안되는 문제 수정 [dev/#344]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.0-release-29 <span className={cx('release-version-title-date')}>( 2019-09-27 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>추가 기능</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 대상자 내보내기 기능 [dev/#339]</div>
                <div className={cx('release-version-list-content')}>
                  - 대상자 내보내기 기능은 선택된 태그, 필터링, 체크한 훈련대상등을
                </div>
                <div className={cx('release-version-list-content continue')}>
                  전부 반영하여 선택된 대상자만 내보내기가 가능합니다.
                </div>
                <div className={cx('release-version-list-content continue')}>
                  (ex> 1개의 태그를 선택하면 선택한 태그의 훈련 대상자만 내려받음, 체크한 대상자만 내려받음)
                </div>
              </div>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  1. 템플릿의 이미지 업로드 부분 깨지는곳 수정 [dev/#340]
                </div>
              </div>
            </div>
          </div>

          <div className={cx('release-version-area')}>
            <div className={cx('release-version-title')}>
              V1.6.0-release-27<span className={cx('release-version-title-date')}>( 2019-09-22 )</span>
            </div>
            <div className={cx('release-version-list')}>
              <div className={cx('release-version-type')}>문제 수정</div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>1. 교육관리 기능을 ie에서 되도록 수정</div>
              </div>
              <div className={cx('release-version-list-each')}>
                <div className={cx('release-version-list-title')}>
                  2. 중국쪽 IP에서 접근 가능하도록 google 관련 호출을 전부 제거
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(Release);



// WEBPACK FOOTER //
// ./src/script/components/mypage/Release.js